/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps, IconSize} from '../types/types';
import useIconDLS from './useIconDLS';

export interface CopyIconProps extends IconProps {
  className?: string;
}

/*
 * Defines the Design Language System (DLS) Copy Icon component.
 */
export const CopyIcon = ({
  size = IconSize.small,
  color,
  iconColor: iconColorOverride,
  className = ''
}: CopyIconProps) => {
  const {iconSize, iconColor} = useIconDLS({size, color});
  const fillColor = iconColorOverride || (color ? iconColor : 'currentColor');

  return (
    <svg className={className} width={iconSize} height={iconSize} viewBox='0 0 30 30' fill='none'>
      <path d='M22 1.333h-16c-1.467 0-2.667 1.2-2.667 2.667v18.667h2.667v-18.667h16v-2.667zM26 6.667h-14.667c-1.467 0-2.667 1.2-2.667 2.667v18.667c0 1.467 1.2 2.667 2.667 2.667h14.667c1.467 0 2.667-1.2 2.667-2.667v-18.667c0-1.467-1.2-2.667-2.667-2.667zM26 28h-14.667v-18.667h14.667v18.667z'
        fill={fillColor} />
    </svg>
  );
};
